import { useUserProfileContext } from "../context/UserProfileContext";

/**
 * useUserProfile - Fetches and exposes user profile data (e.g., balance)
 * Supports optimistic balance updates for better UX
 */
export default function useUserProfile() {
  return useUserProfileContext();
}
